export const validation = {
	badge: {
		validated: "Dados validado",
		pending: "Aguardando validação",
		preExisting: "Pré-existente",
	},
	filter: {
		label: "Status",
		all: "Todos",
		pending: "Aguardando validação",
		validated: "Validados",
	},
	banner: {
		title: "Você possui dados fiscais para validar!",
		message: "Confirme os dados para conseguir utilizar esses perfis fiscais.",
	},
	card: {
		confirmAction: "Confirmar dados",
		validateAction: "Validar dados",
		viewDetails: "Ver detalhes",
	},
	drawerNotice: {
		pendingValidation: "Valide os dados para usar esse perfil fiscal",
	},
	modalConfirm: {
		title: "Confirmar dados fiscais",
		message:
			"Certeza que deseja validar os dados desse perfil fiscal? Ao confirmar ele ficará disponível para ser utilizado no sistema.",
		confirm: "Confirmar dados",
		success: "Dados validados com sucesso!",
	},
	modalReject: {
		title: "Recusar dados fiscais",
		message:
			"Tem certeza que deseja recusar essas alterações? O cadastro voltará ao estado anterior.",
		confirm: "Confirmar recusa",
		success: "Dados recusados.",
	},
	infoBlock: {
		title: "Validação dos dados fiscais",
		validatedAt: "Data/hora da validação",
		validatedBy: "Validado por",
		newBadge: "Novo",
	},
	drawerFooter: {
		confirmData: "Confirmar dados",
		reject: "Recusar",
	},
	form: {
		saveAndValidate: "Salvar e Validar",
		saveAndValidateSuccess: "Salvo e Validado com Sucesso.",
	},
};
